import React from 'react';

export const PORT_BACKEND = ':8080';
export const googleApiKey = '';

export const rootUrlDev = `http://localhost${PORT_BACKEND}/`;
export const rootUrlProd = 'https://backend.uspi.ch/';

export const daysJsFormat = 'D.MM.YYYY';
export const localStorageUserKey = 'uspi_user';

export const apiUrl = () => {
  if (process.env.NODE_ENV !== 'production') {
    return `${rootUrlDev}api`;
  } else {
    return `${rootUrlProd}api`;
  }
};

export const statusOption = [
  {
    label: () => (
      <span
        className={'item-color-select'}
        style={{
          backgroundColor: colors.available,
        }}
      >
        Disponible
      </span>
    ),
    value: 'available',
  },

  {
    label: () => (
      <span
        className={'item-color-select'}
        style={{
          backgroundColor: colors.reserved,
        }}
      >
        Réservé
      </span>
    ),
    value: 'reserved',
  },
  {
    label: () => (
      <span
        className={'item-color-select'}
        style={{
          backgroundColor: colors.rentedSold,
        }}
      >
        Loué
      </span>
    ),
    value: 'rented',
    color: 'red',
  },

  {
    label: () => (
      <span
        className={'item-color-select'}
        style={{
          backgroundColor: colors.rentedSold,
        }}
      >
        Vendu
      </span>
    ),
    value: 'sold',
  },
];

// // inactive, active, banned, disabled
export const statusOptionSimple = [
  {
    label: 'Non activé',
    value: 'inactive',
  },
  {
    label: 'Activé',
    value: 'active',
  },
  {
    label: 'Désactivé',
    value: 'disabled',
  },
];

export const statusUnit = {
  available: 'available',
  rented: 'rented',
  reserved: 'reserved',
};

export const colors = {
  available: '#1890ff',
  reserved: '#0050b3',
  rentedSold: '#bfbfbf',
  primary: '#4F46E5', // Disponible
  secondary: '#E59246', // réservé
  gray: '#A5A5A5', // rented
  blue: '#0a4b67', // rented
  lightgray: '#e0e0e0',
};

export const colorByStatus = (status) => {
  if (status === statusUnit.available) {
    return colors.primary;
  }

  if (status === statusUnit.rented) {
    return colors.gray;
  }

  if (status === statusUnit.reserved) {
    return colors.secondary;
  }
};

export const formatCurrency = (value, withDecorator = true) => {
  if (value === null || value === undefined) {
    return 0;
  }
  const number = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'");

  return `${withDecorator ? 'CHF ' : ''}${number}${withDecorator ? '.-' : ''}`;
};
